var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"border text-sm py-1 px-2 mr-2 mb-2 rounded",class:_vm.active ? 'bg-blue-00 text-blue-50 border-light-blue': 'border-gray-20 text-gray-70',on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }